
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M9.5 1.5H4.333c-.46 0-.833.392-.833.875v1.377m6-2.252v4h4m-4-4 4 4m0 0v9.125c0 .483-.373.875-.833.875H4.333c-.46 0-.833-.392-.833-.875v-3.002"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M2.247 6h4.795M4.196 9h4.3M6.613 12h3.58"}})])
          )
        }
      }
    